import { Component, EventEmitter, Inject, Input, Output } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwSnackbar
 * @module mw.components.snackbar
 *
 * @description
 * The snackbar component (formally known as a toast) is used to provide non-interrupting visual confirmation to the 
 * user that the action they have taken has completed successfully..  It does not require user action to be dismissed,
 * it dismisses automatically after a default timeout.
 *
 * @param {function} [on-close] - A function you want to have called when the snackbar is closed out
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-snackbar on-close="$ctrl.onClose($event)">
 *      <h1> Here is a wonderful snackbar! </h1>
 *      <mw-snackbar-actions>
 *          <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.customAction()">custom action</md-button>
 *      </mw-snackbar-accionts>
 * </mw-snackbar>
 * </hljs>
 */
@Component({
    selector: 'mw-snackbar',
    template: `
        <div class="mw-snackbar">
            <div class="mw-snackbar__content" flex layout="row" layout-nowrap>
                <ng-transclude class="mw-snackbar__text-content"></ng-transclude>
                <ng-transclude class="mw-snackbar__actions" ng-transclude-slot="mwSnackbarActions"></ng-transclude>
                <div class="mw-snackbar__actions">
                    <mw-icon-button class="mw-snackbar__actions-close" svg-icon="navigation:ic_close_24px" ng-click="$ctrl.close($event)"></mw-icon-button>                
                </div>
            </div>
        </div>
    `,
    legacy: {
        transclude: {
            mwSnackbarActions: '?mwSnackbarActions'
        }
    }
})
export class SnackbarComponent {

    @Output() onClose = new EventEmitter<any>();

    constructor() {
    }

    close($event) {
        this.onClose.emit($event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/snackbar/snackbar.component.ts